import Collection from 'cdna/core/collection';
import VideoGroup from './videoGroup.js';

export default Collection.extend({
    model: VideoGroup
});


/** WEBPACK FOOTER **
 ** ./client/video/videoGroupCollection.js
 **/